<div dragula="LAYERS" [(dragulaModel)]="layers">
  <div class="layers-panel__item layer" [ngClass]="{'layer--current':layer == layerData}" *ngFor="let layer of layers">
    <span [ngClass]="{layer__draggable:!layer.locks.depth, layer__infos:true}" (click)="selectLayer(layer)">
      <ng-container *ngIf="layer.type == LayerData.TEXT">
        <span [ngClass]="{layer__draggable:!layer.locks.depth}" class="layer__icon icon icon-font"></span> <span [ngClass]="{layer__draggable:!layer.locks.depth}" class="layer__name">{{ layer.text }}</span>
      </ng-container>
      <ng-container *ngIf="layer.type == LayerData.IMAGE">
        <ng-container *ngIf="layer.special == 'logo'">
          <span [ngClass]="{layer__draggable:!layer.locks.depth}" class="layer__icon icon icon-divide"></span> <span [ngClass]="{layer__draggable:!layer.locks.depth}" class="layer__name">{{ "cfg_logo" | translate }}</span>
        </ng-container>
        <ng-container *ngIf="layer.special == 'background'">
          <span [ngClass]="{layer__draggable:!layer.locks.depth}" class="layer__icon icon icon-photo-camera"></span> <span [ngClass]="{layer__draggable:!layer.locks.depth}" class="layer__name">{{ "cfg_background" | translate }}</span>
        </ng-container>
        <ng-container *ngIf="layer.special != 'background' && layer.special != 'logo'">
          <span [ngClass]="{layer__draggable:!layer.locks.depth}" class="layer__icon icon icon-photo-camera"></span> <span [ngClass]="{layer__draggable:!layer.locks.depth}" class="layer__name">{{ ("cfg_layer_preview_image" | translate)+' '+layer.imageData.name }}</span>
        </ng-container>
      </ng-container>
      <ng-container *ngIf="layer.type == LayerData.SVG_SHAPE">
        <ng-container *ngIf="layer.special == 'logo'">
          <span [ngClass]="{layer__draggable:!layer.locks.depth}" class="layer__icon icon icon-divide"></span> <span [ngClass]="{layer__draggable:!layer.locks.depth}" class="layer__name">{{ "cfg_logo" | translate }}</span>
        </ng-container>
        <ng-container *ngIf="layer.special == 'background'">
          <span [ngClass]="{layer__draggable:!layer.locks.depth}" class="layer__icon icon icon-photo-camera"></span> <span [ngClass]="{layer__draggable:!layer.locks.depth}" class="layer__name">{{ "cfg_background" | translate }}</span>
        </ng-container>
        <ng-container *ngIf="layer.special != 'background' && layer.special != 'logo'">
          <span [ngClass]="{layer__draggable:!layer.locks.depth}" class="layer__icon icon icon-divide"></span> <span [ngClass]="{layer__draggable:!layer.locks.depth}" class="layer__name">{{ "cfg_layer_preview_graphic" | translate }}</span>
        </ng-container>
      </ng-container>
      <ng-container *ngIf="layer.type == LayerData.WINGDINGS_SHAPE || layer.type == LayerData.SQUARE_SHAPE || layer.type == LayerData.TRIANGLE_SHAPE || layer.type == LayerData.CIRCLE_SHAPE || layer.type == LayerData.LINE_SHAPE">
        <span [ngClass]="{layer__draggable:!layer.locks.depth}" class="layer__icon icon icon-divide"></span> <span [ngClass]="{layer__draggable:!layer.locks.depth}" class="layer__name">{{ "cfg_layer_preview_graphic" | translate }}</span>
      </ng-container>
    </span>

    <button class="layer__delete icon icon-delete" (click)="requestLayerDeletion(layer)" *ngIf="!layer.locks.deletion"></button>
    <span class="layer__lock icon icon-lock" *ngIf="layer.locks.deletion"></span>
    <span class="layer__order icon icon-arrows" *ngIf="!layer.locks.depth"></span>
  </div>
</div>

<app-modal id="modal-confirm-layer-deletion" width="640" [blocking]="true" #mcld>
  <p *ngIf="mcld.data?.text" [innerHtml]="mcld.data?.text | translate"></p>

  <div class="modal__buttons">
    <button class="button button--square" (click)='mcld.close()'>
      <span>{{ 'btn_cancel' | translate }}</span>
    </button>

    <button class="button button--square" (click)='deleteLayer(mcld.data?.layer)'>
      <span>{{ 'btn_ok' | translate }}</span>
    </button>
  </div>
</app-modal>